import React from 'react';
import { Stack, Text } from '@efast_public/fjd-component-library';

const KEINE_ANGABE = '- Keine Angabe -';

interface FachdatenV2FieldProps {
  readonly label: string;
  readonly displayValue: string | null;
  readonly showInSection?: boolean;
  readonly suppressLabel?: boolean;
  readonly id?: string;
}

export function FachdatenV2Field({
  label,
  displayValue,
  suppressLabel,
  id
}: FachdatenV2FieldProps) {
  const isEmpty =
    displayValue === null || displayValue === '' || displayValue === ' ';
  const shownValue = isEmpty ? KEINE_ANGABE : displayValue;

  if (suppressLabel) {
    return <Text id={id}>{shownValue}</Text>;
  }

  return (
    <Stack id={id} spacing={'xs'} key={Math.random()}>
      <Text strong>{`${label}:`}</Text>
      <Text>{shownValue}</Text>
    </Stack>
  );
}

export default FachdatenV2Field;
